var generateStyle = function generateStyle(componentTheme) {
  return {
    barLabel: {
      color: componentTheme.barLabelColor,
      fontFamily: componentTheme.barLabelFontFamily,
      fontSize: componentTheme.barLabelFontSize,
      textAnchor: 'middle'
    }
  };
};
export default generateStyle;